enum MutationNames {
  FETCH_SESSIONS_SUCCEEDED = 'FETCH_SESSIONS_SUCCEEDED',
  FETCH_SESSIONS_FAILED = 'FETCH_SESSIONS_FAILED',
  FETCH_SESSIONS_REQUESTED = 'FETCH_SESSIONS_REQUESTED',
  RESET_CATALOG_STORE = 'RESET_CATALOG_STORE',
  UPDATE_PAGE_NUMBER = 'UPDATE_PAGE_NUMBER',
  FETCH_SESSION_FILTERS_REQUESTED = 'FETCH_SESSION_FILTERS_REQUESTED',
  FETCH_SESSION_FILTERS_SUCCEEDED = 'FETCH_SESSION_FILTERS_SUCCEEDED',
  FETCH_SESSION_FILTERS_FAILED = 'FETCH_SESSION_FILTERS_FAILED',
  FORMAT_CATALOG_LIST_REQUEST = 'FORMAT_CATALOG_LIST_REQUEST',
  RESET_FILTER_DATA = 'RESET_FILTER_DATA',
  SET_CURRENT_PROGRAM_IDS_FILTERED = 'SET_CURRENT_PROGRAM_IDS_FILTERED',
  SET_CURRENT_LOCATION_IDS_FILTERED = 'SET_CURRENT_LOCATION_IDS_FILTERED',
  SET_CURRENT_SESSION_DATE_START_FILTER = 'SET_CURRENT_SESSION_DATE_START_FILTER',
  SET_CURRENT_SESSION_DATE_END_FILTER = 'SET_CURRENT_SESSION_DATE_END_FILTER'
}

export default MutationNames;